<template>
  <div>
    <a-drawer
      :height="385"
      placement="bottom"
      :closable="false"
      @close="closeDrawer"
      :wrapStyle="{'padding':'0'}"
      :bodyStyle="{'padding':'0', 'backgroundColor': '#f3f3f3'}"
      :visible="drawervisible">
      <div class="info" @click="closeDrawer"></div>
    </a-drawer>
  </div>
</template>

<script>
export default {
  props: {
  },
  components: {
  },
  data() {
    return {
      drawervisible: false
    };
  },
  created() {
  },
  mounted() {
    
  },
  methods: {
    closeDrawer() {
        this.drawervisible = false;
    },
  },
};
</script>
<style lang="less" scoped>
    .info {
        width: 100%;
        height: 385px;
        background: url('../../../assets/images/info.png') center no-repeat;
        background-size: 100% 100%;
    }
</style>